import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsfEnum } from "@/utils/indicatorsEsf";
import { ResumeIndicatorC7Data } from "@/services/esus/indicator/esf/c7/getResumeIndicatorC7";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsfC7ResumeProps = {
	resume: ResumeIndicatorC7Data;
};

export function IndicatorEsfC7Resume({ resume }: Readonly<IndicatorEsfC7ResumeProps>) {
	const practiceA = calculatePercentage(
		resume.totalCervicalCancerCitizensFinished,
		resume.totalCervicalCancerCitizens
	);
	const practiceB = calculatePercentage(
		resume.totalVaccinationCitizensFinished,
		resume.totalVaccinationCitizens
	);
	const practiceC = calculatePercentage(
		resume.totalAttendanceCitizensFinished,
		resume.totalAttendanceCitizens
	);
	const practiceD = calculatePercentage(
		resume.totalBreastCancerCitizensFinished,
		resume.totalBreastCancerCitizens
	);

	return (
		<Row className="mx-0">
			<Col className="mb-2">
				<CardInformative
					title="Prática A"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${practiceA.toLocaleString()}%`}
					metaData={
						<CardOverlayTrigger
							header="Prática A"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de mulheres, entre 25 e 64 anos, que fizeram <br />
								exame de rastreamento para câncer do colo de útero, solicitado ou{" "}
								<br />
								avaliado nos últimos 36 meses, em relação ao total identificado
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col className="mb-2">
				<CardInformative
					title="Prática B"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${practiceB.toLocaleString()}%`}
					metaData={
						<CardOverlayTrigger
							header="Prática B"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de crianças e adolescentes do sexo feminino, entre
								<br />
								9 e 14 anos, que tiveram pelo menos 1 registro de dose da <br />
								vacina HPV, em relação ao total identificado
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col className="mb-2">
				<CardInformative
					title="Prática C"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${practiceC.toLocaleString()}%`}
					metaData={
						<CardOverlayTrigger
							header="Prática C"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de adolescentes do sexo feminino e mulheres, entre 14 e
								69 anos, <br />
								que tiveram atendimentos presenciais ou remotos sobre atenção à
								saúde sexual <br />e reprodutiva, realizado nos últimos 12 meses, em
								relação ao total identificado
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col className="mb-2">
				<CardInformative
					title="Prática D"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${practiceD.toLocaleString()}%`}
					metaData={
						<CardOverlayTrigger
							header="Prática D"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de mulheres, entre 50 e 69 anos, que fizeram <br />
								exame de rastreamento para câncer de mama, solicitado ou <br />
								avaliado nos últimos 24 meses, em relação ao total <br />
								identificado
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${resume.weightedPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsfEnum.C7,
						resume.weightedPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual alcançado ajustado com os pesos de cada prática segundo a
								portaria.
								<br />
								Prática A: 20 <br />
								Prática B: 30 <br />
								Prática C: 30 <br />
								Prática D: 20 <br />
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
